import { post } from './axios.js'

/**
 * eb_yearly_cashflow_fsct_tb 엑셀 파일 업로드 - /ycf/yearlyCacheFlowFsctExcelUpload
 * @param {Object} params
 * @property {File} params.excel_file - 엑셀 파일
 * @returns
 */
export async function yearlyCacheFlowFsctExcelUpload(params = {}) {
  try {
    const result = await post('/ycf/yearlyCacheFlowFsctExcelUpload', params,{
      headers: {
        "Content-Type": "multipart/form-data",
      }})
    return result.data
  } catch(e) {
    if(e.response.data?.code === '0005') {
      alert('일,월,화만 업데이트 가능합니다.')
      throw new Error(e.response.data.code)
    }else{
      throw new Error(e)
    }
  }
}

/**
 * yearlyCacheFlowRealRsltWeeklyListReport 주차별 캐시플로우 리포트 - /ycf/yearlyCacheFlowRealRsltWeeklyListReport
 * @param {Object} params
 * @property {String} params.fs_year - 엑셀 파일
 * @returns
 */
export async function yearlyCacheFlowRealRsltWeeklyListReport(params = {}) {
  try {
    const result = await post('/ycf/yearlyCacheFlowRealRsltWeeklyListReport',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}



